import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://nvnutrihcqglplrjgofb.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im52bnV0cmloY3FnbHBscmpnb2ZiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc3MTMwNzAsImV4cCI6MjA5MzI4OTA3MH0.YW2PObSshcOqewAZP-as8Smfe5a4YflwALTEVJZ1Kro';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  db: { schema: 'public' },
  global: { headers: { 'x-my-custom-header': 'armstech-erp' } },
  auth: { persistSession: true },
});

export async function setCurrentUser(email) {
  // No-op: user tracking done via logActivity instead
}

export async function logActivity(action, tableName, recordId, description, staffName, oldData, newData) {
  try {
    await supabase.from('activity_logs').insert({
      action, table_name: tableName, record_id: recordId,
      description, staff_name: staffName || '—',
      old_data: oldData || null,
      new_data: newData || null,
    });
  } catch(e) { /* ignore */ }
}
